import { render, staticRenderFns } from "./statements-tab.vue?vue&type=template&id=fdd2af52"
import script from "./statements-tab.vue?vue&type=script&lang=js"
export * from "./statements-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports